import { render, staticRenderFns } from "./medical_record_v2.vue?vue&type=template&id=7a4a70c9&scoped=true"
import script from "./medical_record_v2.vue?vue&type=script&lang=js"
export * from "./medical_record_v2.vue?vue&type=script&lang=js"
import style0 from "./medical_record_v2.vue?vue&type=style&index=0&id=7a4a70c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4a70c9",
  null
  
)

export default component.exports